'use client';

import { Root } from '@radix-ui/react-separator';

import { cn } from '~/utils';

export function Separator({
  className,
  decorative = true,
  orientation = 'horizontal',
  ...props
}: React.ComponentProps<typeof Root>) {
  return (
    <Root
      decorative={decorative}
      orientation={orientation}
      data-slot='separator-root'
      className={cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
}
